export default "__VITE_ASSET__Bwy$iREu__"